import { Entity } from "../helpers/Entity"
import Payment, { PaymentDto } from "../payment/Payment"
import PaymentTransaction, { PaymentTransactionDto } from "../payment/PaymentTransaction"

export type ProposalDocumentDto = {
    pdfUri: string
    type: string
}

export type ProposalAttributes = {
    hash: string
    variables: ProposalVariablesDto
    publicLink: string
}

type CustomerDto = {
    customerAccount : CustomerAccount
}

type CustomerAccount = {
    attributes : CustomerAccountAttributes
}

type CustomerAccountAttributes = {
    globalBalance : number
    owingBalance : number
}

export type GlobalDto = {
    buttonColor: string
    font: string
}

export type ProposalVariablesDto = {
    quote: ProposalQuoteDto
    document: ProposalDocumentDto
    lastPayment: PaymentDto
    global: GlobalDto
    customer : CustomerDto
}
export type ProposalItemDto = {
    id: string
    title: string,
    measure: string,
    type: string,
    groupId: string,
    isEditableQuantity: boolean,
}

export type ProposalQuoteDto = {
    subtotalAmount: number
    totalAmount: number
    totalBottomPriceAmount: number
    currency: string
    items: ProposalItemDto[]
    payments: PaymentTransactionDto[]
}

export interface ProposalDto {
    id: string
    type: string
    attributes: ProposalAttributes
}

export default class Proposal implements Entity {
    id: string
    type: string
    attributes: ProposalAttributes
    constructor(dto: ProposalDto) {
        this.id = dto.id
        this.type = dto.type
        this.attributes = dto.attributes
    }

    isLoaded(): boolean {
        return this.id != "" && this.type == "proposals"
    }

    getId(): string {
        return this.id
    }

    getTotalAmount(): number{
        return this.attributes.variables.quote.totalAmount
    }

    getSubtotalAmount(): number{
        return this.attributes.variables.quote.subtotalAmount
    }

    getProposalHash(): string{
        return this.attributes.hash
    }

    getItems(): ProposalItemDto[]{
        return this.attributes.variables.quote.items
    }

    getCurrency(): string{
        return this.attributes.variables.quote.currency
    }

    getPdfUri(): string {
        return this.attributes.variables.document.pdfUri
    }

    getMostRecentPayment(): Payment | undefined {
        if (this.getProposalType() === "account-statement"){
            if(this.attributes.variables?.lastPayment){
                return new Payment(this.attributes.variables.lastPayment)
            } else {
                return undefined
            }
        }

        if (this.attributes.variables.quote?.payments?.length > 0) {
            const paymentAttribute =
            this.attributes.variables.quote.payments[this.attributes.variables.quote.payments.length - 1].attributes.payment as PaymentDto

            return new Payment(paymentAttribute)
        }
        return undefined
    }

    getPaymentTransactionByPaymentId(paymentId: string): PaymentTransaction | undefined {
        if(this.attributes.variables.quote?.payments?.length > 0){
            const payTrans = this.attributes.variables.quote.payments.find(payTrans => payTrans.attributes.payment.id == paymentId)
            if (payTrans){
                return new PaymentTransaction(payTrans)
            }
        }
        return undefined
    }

    getProposalType(): string {
        return this.attributes.variables.document.type
    }

    getButtonColor(): string {
        return this.attributes.variables.global.buttonColor
    }

    getPublicLink(): string {
        return this.attributes.publicLink
    }

    getCustomerAccountGlobalBalance() : number {
        return this.attributes.variables.customer.customerAccount.attributes.globalBalance
    }

    getCustomerAccountOwingBalance() : number {
        return this.attributes.variables.customer.customerAccount.attributes.owingBalance
    }

}


// WEBPACK FOOTER //
// ./src/state/proposal/Proposal.ts